export default {
  props: {
    item: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      entityImageTypes: ["round-none", "round-sm", "retailer"],
    };
  },
};
